import { render, staticRenderFns } from "./AuthorhistTable.vue?vue&type=template&id=88fd940a&scoped=true&"
import script from "./AuthorhistTable.vue?vue&type=script&lang=js&"
export * from "./AuthorhistTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorhistTable.vue?vue&type=style&index=0&id=88fd940a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd940a",
  null
  
)

export default component.exports